import { api } from './client';

/*  Specchio dei contratti dei testi di stampa.

    Due permessi, e la differenza si vede già qui: `elenco` serve a chi compila un
    preventivo per spuntare quali clausole stampare, tutto il resto serve a chi le
    riscrive. Sono due mestieri diversi — era la richiesta della riunione, «fai in modo
    che non tutti possano scrivere» — e il server li tiene separati.  */

export type GruppoTesto = 'Lettera' | 'Condizioni' | 'ModalitaPagamento';
export type FormaTesto = 'Titolo' | 'Paragrafo' | 'Voce';

export interface TestoStampaLetto {
  id: string;
  gruppo: string;
  forma: string;
  testo: string;
  posizione: number;
  attivo: boolean;
  /** Spuntato in partenza su un preventivo nuovo. Un titolo non lo può essere. */
  predefinito: boolean;
  /*  Di che lavoro parla: «Elettrico», «Meccanico», e quelle che il cliente aggiunge.
      Null vuol dire «vale sempre» — la garanzia non è né elettrica né meccanica, e deve
      uscire su tutte e due.  */
  categoria: string | null;
}

export interface TestoDaScrivere {
  gruppo: string;
  forma: string;
  testo: string;
  predefinito?: boolean;
  /** Sotto quale voce infilarlo. Assente per metterlo in fondo al gruppo. */
  dopoId?: string | null;
  /** Vuoto vuol dire «vale sempre», che è il caso normale. */
  categoria?: string | null;
}

export interface CorrezioneTesto {
  testo: string;
  predefinito: boolean;
  categoria?: string | null;
}

export const testiStampa = {
  /** `tutti` mostra anche i ritirati: serve solo alla schermata di gestione. */
  elenco: (tutti = false) =>
    api.get<TestoStampaLetto[]>(`/testi-stampa${tutti ? '?tutti=true' : ''}`),

  aggiungi: (testo: TestoDaScrivere) => api.post<TestoStampaLetto>('/testi-stampa', testo),

  correggi: (id: string, correzione: CorrezioneTesto) =>
    api.put<TestoStampaLetto>(`/testi-stampa/${id}`, correzione),

  /*  Non c'è una cancellazione, e non per dimenticanza: una clausola citata da
      un'offerta emessa non si può togliere senza perdere la risposta a «cosa avevamo
      scritto». Si ritira, e sparisce da chi compila.  */
  ritira: (id: string, ritirato: boolean) =>
    api.post<TestoStampaLetto>(`/testi-stampa/${id}/ritiro${ritirato ? '' : '?annulla=true'}`, {}),
};
